import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PledgeProductRead } from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }) {
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        realEstateProgramName: [
          entity?.parameters?.realEstateProgramName || null,
        ],
        realEstatePromoterName: [
          entity?.parameters?.realEstatePromoterName || null,
        ],
        realEstateReference: [entity?.parameters?.realEstateReference || null],
        realEstateFloor: [entity?.parameters?.realEstateFloor || null],
        realEstateDescription: [
          entity?.parameters?.realEstateDescription || null,
        ],
        realEstateHasParking: [
          entity?.parameters?.realEstateHasParking || false,
        ],
        realEstateHasCellar: [entity?.parameters?.realEstateHasCellar || false],
        realEstateRent: [entity?.parameters?.realEstateRent || null],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as FormArray;
  }
  extract() {
    const formValue = _.cloneDeep(this.form.value);
    return formValue.products;
  }
}
